module.exports = __webpack_public_path__ + "img/pinshu.330fb922.jpg";